import React from 'react'
import Home from './Home'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from './Contact';
// import About from './About';
import RefundPolicy from './pages/RefundPolicy';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GrievanceRedressalPolicy from './pages/GrievanceRedressalPolicy';
import TermsCondition from './pages/TermsCondition';
import AboutUs from './pages/AboutUs';
import Services from './Services';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/contact" element={<Contact />} /> 
         {/* <Route path="/about" element={<About />} />  */}
         {/* app pages */}
          <Route path="/refund" element={<RefundPolicy />} /> 
          <Route path="/contact-us" element={<ContactUs />} /> 
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
          <Route path="/grievance-redressal-policy" element={<GrievanceRedressalPolicy />} /> 
          <Route path="/terms-condition" element={<TermsCondition />} /> 
          <Route path="/about" element={<AboutUs />} /> 
          <Route path="/services" element={<Services />} /> 
      </Routes>
    </Router>
  )
}

export default App
